
import OabatTextFieldSearchIcon from "@/components/base/design/OabatTextFieldSearchIcon"
import TypingPlaceholder from "@/components/base/input/TypingPlaceholder"

export default {
    name: "SearchWrapper",
    components: {
        OabatTextFieldSearchIcon,
        TypingPlaceholder,
    },
    /** open:
     * clear: if search should be cleared
     * input: dialogs open state for v-model binding
     */
    emits: ["input"],
    props: {
        /** Placeholder suggestions with typing animation */
        suggestions: {
            type: Array,
            default: () => [],
        },
        /** Placeholder string. Replace suggestion slot with %s */
        placeholder: {
            type: String,
            default: "Gib z.B.",
        },
    },
    data() {
        return {
            isFocussed: false,
            search: "",
        }
    },
    computed: {
        isSearchEmpty() {
            return this.search?.length < 1
        },
        prefix() {
            const parts = this.placeholder.split("%s")
            if (parts.length < 1) return ""
            return parts[0]
        },
        suffix() {
            const parts = this.placeholder.split("%s")
            if (parts.length < 2) return ""
            return parts[1]
        },
    },
    methods: {
        onSearchChange(newVal) {
            this.search = newVal
        },
    },
}
